import { api, ApiError } from "../api.js";
import { h, eraLabel } from "../ui.js";
import type { App } from "../main.js";

/** Handle picker for the active era (platform spec §3.1, §4.1 /create). */
export function createView(app: App): HTMLElement {
  const era = app.me.era?.id ?? "pre_alpha";
  const input = h("input", { class: "input", type: "text", name: "handle", maxlength: "16", pattern: "[A-Za-z0-9_]{3,16}", placeholder: "3–16 letters, digits, _", autofocus: true, autocomplete: "off" });
  const msg = h("div");
  const prior = app.me.history?.filter((p) => p.archived_at) ?? [];
  return h("div", { class: "stack" },
    h("div", { class: "panel" },
      h("h1", {}, `New character · ${eraLabel(era)}`),
      h("p", { class: "dim" }, "Accounts are permanent. Each era starts a fresh character; what you did in earlier eras stays on your account forever."),
      prior.length ? h("p", { class: "dim" }, `You were here before: ${prior.map((p) => `${p.handle} (${eraLabel(p.era_id)})`).join(", ")}.`) : null,
      h("form", {
        onsubmit: async (e: Event) => {
          e.preventDefault();
          try {
            await api.createProfile(input.value.trim());
            if (!app.me.account?.ageOk) await api.ageOk();
            app.go("/home");
          } catch (err) {
            msg.replaceChildren(h("div", { class: "msg error" }, err instanceof ApiError ? err.message : "Something went wrong"));
          }
        },
      },
        h("div", { class: "stack" },
          h("div", { class: "field" }, h("label", { for: "handle" }, "Handle"), input),
          h("label", { class: "row", style: "font-size:12px" }, h("input", { type: "checkbox", required: true, checked: app.me.account?.ageOk ? true : undefined }), "I am 13 or older."),
          msg,
          h("button", { class: "btn primary", type: "submit" }, "Create"),
        ),
      ),
    ),
  );
}
